import { render, staticRenderFns } from "./RequestForChangeDialog.vue?vue&type=template&id=f84be34c"
import script from "./RequestForChangeDialog.vue?vue&type=script&lang=ts"
export * from "./RequestForChangeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports